import { Star, StarHalf } from "lucide-react";

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: "sm" | "md" | "lg" | "full";
  showText?: boolean;
  className?: string;
}

export function StarRating({
  rating,
  maxRating = 5,
  size = "md",
  showText = false,
  className = "",
}: StarRatingProps) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = maxRating - fullStars - (hasHalfStar ? 1 : 0);

  const sizeClass = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
    full: "h-full w-full",
  }[size];

  return (
    <div className={`flex h-full items-center gap-1 ${className}`}>
      {[...Array(fullStars)].map((_, i) => (
        <Star key={`full-${i}`} className={`${sizeClass} fill-yellow-400 text-yellow-400`} />
      ))}
      {hasHalfStar && <StarHalf className={`${sizeClass} fill-yellow-400 text-yellow-400`} />}
      {[...Array(emptyStars)].map((_, i) => (
        <Star key={`empty-${i}`} className={`${sizeClass} text-muted-foreground`} />
      ))}
      {showText && <span className="ml-1 text-sm font-medium">{rating.toFixed(1)}</span>}
    </div>
  );
}
